<app-modal class="operation-type-create-modal" [isLoading]="isLoading">
    <ng-container modal-header>
        <h5 class="modal-title" *ngIf="!isEditMode; else editTitle">{{
                'admin.tickets.operation-types.create-modal.title'
                    | translate
            }}</h5>
        <ng-template #editTitle>
            <h5 class="modal-title">{{ 'admin.tickets.operation-types.update-modal.title' | translate }}</h5>
        </ng-template>
    </ng-container>
    <ng-container modal-body>
        <form class="picklist-form" [formGroup]="operationTypeForm">
            <div class="form-group row">
                <div class="col s12">
                    <app-input [formControl]="operationTypeForm.controls['name']"
                               [(ngModel)]="operationType.name"
                               [showErrors]="showValidations"
                               placeholder="{{'admin.tickets.operation-types.create-modal.name-input.placeholder' | translate }}"
                               label="{{'admin.tickets.operation-types.create-modal.name-input.label' | translate}}">
                    </app-input>
                </div>
            </div>
            <div class="row">
                <div class="col s12">
                    <app-input
                        type="number"
                        [formControl]="operationTypeForm.controls['priority']"
                        [(ngModel)]="operationType.priority"
                        [showErrors]="showValidations"
                        placeholder="{{'admin.tickets.operation-types.create-modal.priority-input.placeholder' | translate }}"
                        label="{{'admin.tickets.operation-types.create-modal.priority-input.label' | translate}}">
                    </app-input>
                </div>
            </div>
        </form>
    </ng-container>
    <ng-container modal-footer>
        <app-button type="simple"
                    [disabled]="isLoading"
                    (click)="modal.close()">
            {{ 'generic.buttons.close' | translate }}
        </app-button>
        <div class="mutators">
            <app-button *ngIf="!isEditMode && shouldRenderModifiers()"
                        type="primary"
                        [disabled]="isLoading"
                        (click)="createOperationType()">
                {{ 'generic.buttons.create'| translate }}
            </app-button>
            <app-button *ngIf="isEditMode && shouldRenderModifiers()"
                        type="warning"
                        [disabled]="isLoading"
                        (click)="updateOperationType()">
                {{ 'generic.buttons.update'| translate }}
            </app-button>
            <app-button
                type="danger"
                class="btn btn-danger"
                *ngIf="isEditMode && shouldRenderModifiers()"
                [disabled]="operationType.inUse || isLoading"
                (click)="deleteOperationType()">
                {{ 'generic.buttons.delete' | translate }}
            </app-button>
        </div>
    </ng-container>
</app-modal>
